import en from './translations/en.json'
import kr from './translations/kr.json'

export default {
    en, kr
}